// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Bu","floatingBox":"e_Cu","floatingAd":"e_Du"};